import React from 'react';
import { formatCurrency } from '@avila-tek/ui/src';
import { useUser } from '../../../hooks';
import { roles } from '../../../static';

interface ItemQuantityProps {
  price: number;
  quantity: number;
  canEdit?: boolean;
  comparateAtPrice?: number;
}

function ItemQuantity({
  price,
  quantity,
  canEdit = true,
  comparateAtPrice,
}: ItemQuantityProps) {
  const [user] = useUser();
  return (
    <div className="flex flex-row h-10  rounded-lg relative bg-transparent mt-1">
      {canEdit ? (
        <button
          type="button"
          className="  text-gray-600 h-full w-10 rounded-l cursor-pointer outline-none"
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          <span className="m-auto text-2xl text-neutral-cold-400">−</span>
        </button>
      ) : null}
      <span
        className={`flex justify-center flex-col sm:flex-row focus:outline-none text-center w-full font-semibold text-md hover:text-black focus:text-black md:text-base cursor-default items-center text-neutral-cold-400 outline-none ${
          user.userType === roles.admin ? 'space-x-3' : ''
        }`}
      >
        <div className="flex flex-col justify-center items-end">
          <span className="text-purple-300 font-semibold">
            ${formatCurrency(price)}
          </span>{' '}
          {user.userType === roles.admin && comparateAtPrice ? (
            <span className="text-neutral-cold-400 font-semibold text-sm line-through">
              ${formatCurrency(comparateAtPrice)}
            </span>
          ) : null}
        </div>
        <span className="ml-1"> x {quantity ?? 0}</span>
      </span>
      {canEdit ? (
        <button
          type="button"
          className=" text-gray-600  h-full w-10 rounded-r cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          <span className="m-auto text-2xl text-neutral-cold-400 ">+</span>
        </button>
      ) : null}
    </div>
  );
}

export default ItemQuantity;
